import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../../components/Wrapper/Wrapper';
import { DataGrid } from '@material-ui/data-grid';
import { connect } from "react-redux";
import { logoutUser } from "../../../../store/actions/authActionCreators";
import {
  getTripDetailsV3,
  getJourneyDetails,
  updateNoteTrip,
  addNewNoteTrip,
  updateTrip,
  updateTripEditArrowFlag,
  updateTripEditModalFlag,
  updateTripStatus,
  updateTripNotes,
  addPartyExpense,
  addNewPod,
  deleteTripPod,
  updateTripPodsCTA,
  deleteTrip,
  deleteTripNote
} from "../../../../store/actions/tripActionCreator";
import { backButtonStatusUpdate } from '../../../../store/actions/userActionCreators';
import {
  TRIP_STATUS,
  TRIP_DISPLAY_STATUS,
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  PAYMENT_CHIPS
} from "../../../../store/constants";
import MUIDataTable from "mui-datatables";
import * as logger from "../../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat } from '../../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../../css/views';
import ViewPageLayout from '../../../components/PageLayout/ViewPageLayout';
import { trackDwebEvent } from "../../../analytics";
import RouteInfo from '../../../components/Trip/RouteInfo';
import Info from '../../../components/Trip/Info';
import TripTimeline from '../../../components/Trip/TripTimeline';
import TripActionsCard from '../../../components/Trip/TripActionsCard';
import ProfitSummary from '../../../components/Trip/ProfitSummary';
import PartySummary from '../../../components/Trip/PartySummary';
import VendorSummary from '../../../components/Trip/VendorSummary';
import TripTimelineAction from '../../../components/Trip/TripTimelineActionDialog';
import ComingSoonModal from '../../../components/ComingSoonModal/comingSoonModal';
import { TextField } from 'mui-rff';
import { Form } from 'react-final-form';
import TextInputState from '../../../components/Inputs/TextInputState';
import { sendError, sendSucces } from "../../../../utils/utils";
import { updateFreeTrialModal } from "../../../../store/actions/paymentsActionCreator";
import { getTripLedgerData } from '../../../../store/actions/homeActionCreator';
import FreeTrialAlertsDialog from '../../../components/Dialog/FreeTrialAlertsDialog';
import SimTrackingPopUp from '../../../components/Dialog/SimTrackingPopUp';
// import SimTrackingDialog from '../../SimTracking/SimTracking';
import CheckApprovalDialog from '../../SimTracking/CheckApproval';
import JourneyTruckCard from './JourneyTruckCard';
import JourneyDriverCard from './JourneyDriverCard';
import JourneyAssignDriverCard from './JourneyAssignDriverCard';
import JourneyTripsTabs from './JourneyTripsTabs';
import JourneyTripProfitExpenseCard from './JourneyTripProfitExpenseCard';
import JourneyTripsPODBiltyTabs from './JourneyTripsPODBiltyTabs';
// import JourneySimTrackingCard from './JourneySimTrackingCard';
const ViewJourney = ({ user, payments, dispatchUpdateBack, location, dispatchTripDetailsAction, dispatchGetTripLedgerAction, dispatchUpdateModal, dispatchUpdateNoteTrip, dispatchAddNoteTrip, dispatchUpdateTrip, dispatchDeleteTripNote, trip }) => {
  const classes = useStyles();
  let history = useHistory();
  let path = location && location.pathname ? location.pathname.split("/") : [];
  const [tripTimelineActionOpen, setTripTimelineActionOpen] = useState(false);
  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const [noteValue, setNoteValue] = useState("");
  const [changeNoteFlag, setChangeNoteFlag] = useState(false);
  const [changeMaterialFlag, setChangeMaterialFlag] = useState(false);
  const [freeTrailOpen, setFreeTrailOpen] = useState(false);
  const [simTrackingPopUp, setSimTrackingPopUp] = useState(false);
  const [biltyPopUp, setBiltyPopUp] = useState(false);

  const [simTrackingDialogOpen, setSimTrackingDialogOpen] = useState(false);
  const [simTrackingCheckApproval, setSimTrackingCheckApproval] = useState(false);
  const [staticStatus, setStaticStatus] = useState(false);
  const [consentPending, setConsentPending] = useState(false);
  const [locationPolling, setLocationPolling] = useState(false);

  const [activeTab, setActiveTab] = useState(0);
  const onTripTabChange = (val) => {
    setActiveTab(val)
  }
  const today = new Date();

  let tripId = "";
  if (path && path.length && path[path.length - 1]) {
    tripId = path[path.length - 1];
  }

  let tripDetails = user.singleTripData ? user.singleTripData : {};
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let vehicleData = tripDetails && tripDetails.vehicle && tripDetails.vehicle.vehicleId ? tripDetails.vehicle : null
  let vehicleTrackingData = vehicleData && vehicleData.tracking ? vehicleData.tracking : null
  let hiredTrip = tripDetails && tripDetails.vehicle && tripDetails.vehicle.ownershipType && tripDetails.vehicle.ownershipType == 'HIRED' ? true : false;
  let tripNote = tripDetails && tripDetails.notes && tripDetails.notes.STARTED && tripDetails.notes.STARTED[0] ? tripDetails.notes.STARTED[0] : "";



  const [materialValue, setMaterialValue] = useState(tripDetails && tripDetails.material ? tripDetails.material : "");
  useEffect(() => {
    if (typeof window != 'undefined') {
      window.onpopstate = () => {
        dispatchUpdateBack("fromViewTrip")
      }
    }
  }, [])
  useEffect(() => {

    let tripNote = tripDetails && tripDetails.notes && tripDetails.notes.STARTED && tripDetails.notes.STARTED[0] ? tripDetails.notes.STARTED[0] : "";

    if (tripNote && tripNote.id) {
      setNoteValue(tripNote.note);
    } else {
      setNoteValue("");
    }

    if (tripDetails && tripDetails.material) {
      setMaterialValue(tripDetails.material)
    } else {
      setMaterialValue("");
    }
  }, [tripDetails, user.singleTripData]);


  const initialValues = {
    material: materialValue ? materialValue : tripDetails.material,
    notes: noteValue,
  }

  const handleComingSoonOpen = () => {
    setComingSoonOpen(true);
  }
  const handleComingSoonClose = () => {
    setComingSoonOpen(false);
  }
  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(tripId, () => {
      if (user.singleTripData) {
        trackDwebEvent("Dweb Single Trip Page", {
          trip_id: tripId,
          party_id: user.singleTripData.party && user.singleTripData.party.customerId,
          party_name: user.singleTripData.party && user.singleTripData.party.name,
          vehicle_id: user.singleTripData.vehicle && user.singleTripData.vehicle.id,
          vehicle_number: user.singleTripData.vehicle && user.singleTripData.vehicle.number,
          trip_status: user.singleTripData.status
        });
      }
    });
  }
  useEffect(() => {
    if (tripId) {
      fetchTrip(tripId)
    }
  }, [dispatchTripDetailsAction]);

  const getFormFields = (values) => {
    return [
      {
        size: 12,
        visible: true,
        field: (
          <>
            <div>
              <div className={classes.title}>Material</div>
              <TextInputState
                // label={totalUnitsLabel}
                placeholder="Eg: Iron"
                onChange={(e) => {
                  setMaterialValue(e.target.value)
                  setChangeMaterialFlag(true);
                }}
                onBlur={() => handleMaterial()}
                name="material"
                fullWidth={true}
                variant="outlined"
                size="small"
                required={true}
                className={classes.mtV1}
              />
            </div>
          </>
        )
      },
      {
        size: 12,
        visible: true,
        field: (
          <>
            <div className={classes.mtV3}>
              <div className={classes.titleV1}>Notes</div>
              <TextField
                placeholder="Notes"
                name="notes"
                variant="outlined"
                size="small"
                multiline={true}
                rows={3}
                rowsMax={3}
                onChange={(e) => {
                  setNoteValue(e.target.value);
                  setChangeNoteFlag(true);
                }}
                onBlur={(e) => handleNoteChange(e.target.value)}
              />
            </div>
          </>
        )
      }
    ]
  };

  const onSubmit = () => {

  }

  const handleNoteChange = () => {

    setChangeNoteFlag(false);

    if (tripNote && tripNote.id && noteValue.trim() && changeNoteFlag) {

      dispatchUpdateNoteTrip(
        tripDetails.id,
        tripNote.id,
        {
          note: noteValue.trim()
        },
        (data) => {
          if (data && data.status && data.status.code == 200) {
            logger.log('View Trip Component', 'Update Note Successfull');
          }
        },
        () => {
          logger.log('View Trip Compoennt', 'Update Note Failed');
        }
      );
    } else if (noteValue.trim() && changeNoteFlag) {

      let notesValue = [];

      notesValue.push({
        note: noteValue.trim(),
        noteReceivedDate: Math.round((today.getTime() / 1000))
      })

      dispatchAddNoteTrip(
        tripDetails.id,
        {
          notes: notesValue,
          tripStatus: "STARTED",
          fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
          fleet_owner_id: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
          fo_id: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
        },
        (data) => {
          if (data && data.status && data.status.code == 200) {
            logger.log('View Trip SideBar', 'Add Note Successfull');
          }
        },
        () => {
          logger.log('View Trip SideBar', 'Add Note Failed');
        }
      )

    } else if (tripNote && tripNote.id && !noteValue.trim() && changeNoteFlag) {

      dispatchDeleteTripNote(
        tripDetails.id,
        tripNote.id,
        (data) => {
          if (data && data.status && data.status.code == 200) {
            logger.log('View Trip SideBar', 'Add Note Successfull');
          }
        },
        () => {
          logger.log('View Trip SideBar', 'Add Note Failed');
        }
      )

    }

  }

  const handleMaterial = () => {

    setChangeMaterialFlag(false);
    let tripId = tripDetails && tripDetails.id ? tripDetails.id : ""

    if (tripId && changeMaterialFlag && materialValue.trim()) {
      let updateTrip = {
        material: materialValue ? materialValue : "",
      };

      dispatchUpdateTrip(
        tripId,
        updateTrip,
        (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            sendSucces("Trip Updated Successfully!");
          }
        },
        (data) => {
          logger.log("View Trip Component Dweb", "Trip Update Failed");
        },
      );
    }
  }

  const onActionEnd = () => {
    if (tripId) {
      fetchTrip(tripId)
    }
  }
  const handleTripTimelineActionClose = (status) => {
    setTripTimelineActionOpen(status);
    if (tripId) {
      fetchTrip(tripId)
    }
  }
  const handleTripTimelineActionOpen = (status) => {
    if (tripStatus == 'PAYMENT_RECEIVED') {
      handleComingSoonOpen()
    } else {
      setTripTimelineActionOpen(true);
    }
  }

  const handleFreeTrialClose = (status) => {
    setFreeTrailOpen(false);
  };

  const handleFreeTrialConfirm = (status) => {
    setFreeTrailOpen(false);
    goToPremium();
  };

  const goToPremium = (data) => {
    history.push({
      pathname: `/payments`,
      state: {
        id: 1,
        pageTitle: 'Premium'
      }
    });
  }

  const handleSimTrackingPopUpClose = () => {
    setSimTrackingPopUp(false);
  }

  const goToSimTracking = () => {
    dispatchTripDetailsAction(tripId,
      (data) => {
        if (data && data.status && data.status.code == 200) {
          if (data.response && data.response.vehicle && !data.response.vehicle.tracking_status) {
            setSimTrackingDialogOpen(true);
            setSimTrackingCheckApproval(false);
          } else if (data.response && data.response.vehicle && data.response.vehicle.tracking_status == "consent_pending") {
            setSimTrackingCheckApproval(true);
            setConsentPending(true);
            setSimTrackingDialogOpen(false);
            setStaticStatus(false);
            setLocationPolling(false);
          } else if (data.response && data.response.vehicle && data.response.vehicle.tracking_status == "static") {
            setSimTrackingCheckApproval(true);
            setStaticStatus(true);
            setConsentPending(false);
            setSimTrackingDialogOpen(false);
            setLocationPolling(false);
          } else if (data.response && data.response.vehicle && data.response.vehicle.tracking_status == "location_polling") {
            setStaticStatus(false);
            setConsentPending(false);
            setSimTrackingDialogOpen(false);
            if (data.response && data.response.vehicle && data.response.vehicle.location_points && data.response.vehicle.location_points.length == 0) {
              setSimTrackingCheckApproval(true);
              setLocationPolling(true);
            } else if (data.response && data.response.vehicle && data.response.vehicle.location_points && data.response.vehicle.location_points.length > 0) {
              setSimTrackingCheckApproval(false);
              setLocationPolling(false);
              history.push({
                pathname: `/trips/sim-tracking-map/${tripId}`,
                // component: MapComponent,
                state: {
                  id: 1,
                  pageTitle: data.response && data.response.vehicle && data.response.vehicle.driverName ? data.response.vehicle.driverName : "",
                  sourceLocation: data.response && data.response.startLocation ? data.response.startLocation : "",
                  destinationLocation: data.response && data.response.destinationLocation ? data.response && data.response.destinationLocation : ""
                }
              })
            }
          } else if (data.response && data.response.vehicle && data.response.vehicle.tracking_status == "completed") {
            if (data.response && data.response.vehicle && data.response.vehicle.location_points && data.response.vehicle.location_points.length > 0) {
              setStaticStatus(false);
              setConsentPending(false);
              setSimTrackingDialogOpen(false);
              setSimTrackingCheckApproval(false);
              setLocationPolling(false);
              history.push({
                pathname: `/trips/sim-tracking-map/${tripId}`,
                // component: MapComponent,
                state: {
                  id: 1,
                  pageTitle: data.response && data.response.vehicle && data.response.vehicle.driverName ? data.response.vehicle.driverName : "",
                  sourceLocation: data.response && data.response.startLocation ? data.response.startLocation : "",
                  destinationLocation: data.response && data.response.destinationLocation ? data.response && data.response.destinationLocation : ""
                }
              })
            }
          }
        }
      },
      () => {

      }
    );
  }

  const handleSimTrackingDialogClose = () => {
    setSimTrackingDialogOpen(false);
  }

  const handleConsentPendingClose = () => {
    setSimTrackingCheckApproval(false);
  }

  const handleBiltyPopUpClose = () => {
    setBiltyPopUp(false);
  }

  return (
    <>
      <div className={classes.journeyPage}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <JourneyTruckCard vehicle={tripDetails && tripDetails.vehicle ? tripDetails.vehicle : null} updateJourney={fetchTrip} />
              </Grid>
              <Grid item xs={6}>
                {tripDetails && tripDetails.driver &&
                  tripDetails.driver.driverId ?
                  <JourneyDriverCard updateJourney={fetchTrip} driver={tripDetails && tripDetails.driver ? tripDetails.driver : null} /> : <JourneyAssignDriverCard fetchJourney={fetchTrip} journey={tripDetails ? tripDetails : null} />}
              </Grid>
              <Grid item xs={12}>
                <JourneyTripsTabs onTripTabChange={onTripTabChange} activeTab={activeTab} journey={tripDetails ? tripDetails : null} updateJourney={fetchTrip} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
            <Grid item xs={12}>
              <JourneyTripProfitExpenseCard updateJourney={fetchTrip} journey={tripDetails ? tripDetails : null} customersList={tripDetails && "customers" in tripDetails ? tripDetails.customers : []} />
            </Grid>
            {/* {(vehicleTrackingData && "trackingStatus" in vehicleTrackingData && vehicleTrackingData.trackingStatus == "completed" && ((!vehicleTrackingData.locationPoints) || (vehicleData && "locationPoints" in vehicleData && vehicleData.locationPoints.length == 0))) ?
              null
              :
              <Grid item xs={12}>
                <JourneySimTrackingCard fetchJourney={fetchTrip} journey={tripDetails ? tripDetails : null} />
              </Grid>
            } */}
            <Grid item xs={12}>
              <JourneyTripsPODBiltyTabs onTripTabChange={onTripTabChange} activeTab={activeTab} updateJourney={fetchTrip} journey={tripDetails ? tripDetails : null} />
            </Grid>
          </Grid>
        </Grid>
      </div>
      {comingSoonOpen && <ComingSoonModal open={comingSoonOpen} onClose={handleComingSoonClose} />}
      {/* {freeTrailOpen && <FreeTrialAlertsDialog confirmOpen={freeTrailOpen} status={payments.subscriptionStatus} onClose={handleFreeTrialClose} onConfirm={handleFreeTrialConfirm} />} */}
      {/* {simTrackingPopUp && <SimTrackingPopUp open={simTrackingPopUp} onClose={handleSimTrackingPopUpClose} onTrack={goToSimTracking} />} */}
      {/* {simTrackingDialogOpen && <SimTrackingDialog open={simTrackingDialogOpen} onClose={handleSimTrackingDialogClose} />} */}
      {/* {simTrackingCheckApproval && <CheckApprovalDialog open={simTrackingCheckApproval} onClose={handleConsentPendingClose} staticValue={staticStatus} consentPendingValue={consentPending} locationPollingValue={locationPolling} />} */}
    </>
  );
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchLogoutAction: () => dispatch(logoutUser()),
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getJourneyDetails(tripId, onSuccess, onError)),
  dispatchUpdateNoteTrip: (tripId, noteId, data, onSuccess, onFailure) => {
    dispatch(updateNoteTrip(tripId, noteId, data, onSuccess, onFailure))
  },
  dispatchUpdateTrip: (tripId, trip, onSuccess, onError) => {
    dispatch(updateTrip(tripId, trip, onSuccess, onError));
  },
  dispatchAddNoteTrip: (tripId, data, onSuccess, onError) => {
    dispatch(addNewNoteTrip(tripId, data, onSuccess, onError))
  },
  dispatchUpdateModal: (value) => {
    dispatch(updateFreeTrialModal(value))
  },
  dispatchUpdateBack: (value) => {
    dispatch(backButtonStatusUpdate(value))
  },
  dispatchDeleteTripNote: (tripId, noteId, onSuccess, onError) => {
    dispatch(deleteTripNote(tripId, noteId, onSuccess, onError))
  },
  dispatchGetTripLedgerAction: (requestData, onSuccess, onFailure) =>
    dispatch(
      getTripLedgerData(
        requestData, onSuccess, onFailure
      )
    ),
});
const ViewTripWithRouter = withRouter(ViewJourney);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewTripWithRouter);
